import styled from "styled-components";

export const PeakCartonCountContainer = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 1em 1.5em;
  max-height: 5em;
  flex: 1;
  ${(props) =>
    props.bold &&
    `
   font-weight: bold;
    font-size: 1.2em;
   `};
`;

export const RecruitmentViewMainGrid = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-template-rows: repeat(7, 1fr);
  grid-template-areas:
    "callout callout callout callout callout callout tableA tableA tableA tableA"
    "callout callout callout callout callout callout tableA tableA tableA tableA"
    "callout callout callout callout callout callout tableA tableA tableA tableA"
    "tableB tableB tableB tableB tableB tableB tableB tableB tableB tableB"
    "tableB tableB tableB tableB tableB tableB tableB tableB tableB tableB"
    "tableB tableB tableB tableB tableB tableB tableB tableB tableB tableB"
    "tableB tableB tableB tableB tableB tableB tableB tableB tableB tableB";
`;

export const VerticalTableHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 10em;
  background-color: #eeeeee;
  overflow-x: scroll;
  border-right: 1px solid #cfd8dc;
`;

export const VerticalTableHeaderItem = styled.div`
  display: flex
  justify-content: center;
  align-items: center;
  flex: 1;
  font-weight: bold;
`;

export const HorizontallyScrollable = styled.div`
  display: flex;
  flex: 1;
  overflow-x: scroll;
  box-sizing: content-box;
  max-width: calc(100vw - 10em);
  flex-direction: column;
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;
export const HeaderRowItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 10em;
  font-weight: bold;
  background-color: #e1f5fe;
  border-right: 1px solid #cfd8dc;
  border-bottom: 1px solid #cfd8dc;
`;

export const EntryRowContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 5;
`;

export const EntryRow = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

export const EntryItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 10em;
  border-right: 1px solid #cfd8dc;
  border-bottom: 1px solid #cfd8dc;
`;

export const TableAVerticalHeaders = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0.6;
  background-color: #eeeeee;
  border-bottom: 1px solid #cfd8dc;
`;

export const TableAMainFlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

export const ItemsMainContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const ItemRow = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  border-bottom: 1px solid #cfd8dc;
`;

export const HeaderItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e1f5fe;
  flex: 1;
  border-right: 1px solid #cfd8dc;
`;

export const Item = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  border-right: 1px solid #cfd8dc;
`;
